import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const faqs = [{
  question: '¿Y si no tengo tiempo?',
  answer: 'Este eBook es precisamente para eso. Está pensado para leerse en tramos de diez minutos, entre una cosa y otra. Si esperas a tener tiempo, quizá sea demasiado tarde: el momento no es cuando puedas, es ahora.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Al completar tu pago recibes de inmediato un correo con el enlace de descarga del eBook y de los 6 bonos. Todo es digital: sin esperas, sin envíos y sin costos adicionales.'
}, {
  question: '¿Lo puedo leer desde el celular?',
  answer: 'Sí. Está en PDF, así que puedes leerlo desde el celular, la tablet o el computador, e imprimir los ejercicios y planificadores las veces que quieras.'
}, {
  question: '¿Sirve si ya intenté antes y no funcionó?',
  answer: 'Sobre todo si ya lo intentaste. Aquí no hay motivación vacía: hay ejercicios concretos, un reto guiado de 30 días y herramientas para sostener el cambio cuando la emoción inicial se acaba.'
}, {
  question: '¿Es solo para mamás?',
  answer: 'No. Es para toda mujer que se dejó de última: mamás, cuidadoras, profesionales, mujeres que sostienen a todos y a nadie le cuentan cómo están.'
}, {
  question: '¿Los bonos son realmente gratis?',
  answer: 'Sí. Su valor real es de $92.400 y hoy se incluyen sin costo con tu eBook. Es una promoción de lanzamiento y puede cerrarse en cualquier momento.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-sand py-20 sm:py-28" aria-labelledby="faq-title" data-id="element-43" data-mp="1t53fi0hpjwn">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-44" data-mp="3jz191lytnp6r">
        <SectionHeading eyebrow="Antes de decidir" title="Preguntas honestas" data-id="element-45" data-mp="3nzk1ni8jgza0" />

        <ul className="mt-12 space-y-3" data-id="element-46" data-mp="3o1o8o91qieei">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl bg-cream" data-id="element-47" data-mp="1ppunekfv3hkw" data-mpi={index}>
                <h3 data-id="element-48" data-mp="1kqi58czxqyon">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left transition-colors hover:bg-blush/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-plum" data-id="element-49" data-mp="1ks2vvrj4pxh8">
                    <span className="font-display text-xl text-plum sm:text-2xl" data-id="element-50" data-mp="23jlz9zh2fdjs">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-clay transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-51" data-mp="s2m9pbm3rctg" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-52" data-mp="33qr46u3emy41">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-53" data-mp="38ok9lkwvvo39">
                      <p className="px-6 pb-6 text-base leading-relaxed text-ink/75" data-id="element-54" data-mp="3ncx6ql7pjczc">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}